import React, { Suspense, lazy } from 'react';

import ApiErrorBoundary from '@components/Common/Error/ApiErrorBoundary';

const ClientAccountDetailForm = lazy(
  () => import('@components/ClientAccount/ClientAccountDetailForm')
);

/** 마스터 계정 > 회사 계정 관리 > 상세 */
const ClientAccountDetail = () => {
  return (
    <>
      <ApiErrorBoundary>
        <Suspense>
          <ClientAccountDetailForm />
        </Suspense>
      </ApiErrorBoundary>
    </>
  );
};

export default ClientAccountDetail;
